import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  appsMenuBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0px 8px',
    borderRadius: '0px',
    borderLeft: `1px solid ${theme.evPalette.charcoal[300]}`,
    '&.open': {
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  appsMenuMobileBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0px',
    borderRadius: '0px',
    width: '100%',
    '&>.myev-MuiButton-label': {
      width: '100%',
      justifyContent: 'space-between',
      color: theme.evPalette.ocean[600],
    },
    '&.open': {
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  appsIconWithText: {
    display: 'flex',
    padding: '10px',
    gap: '20px',
  },
  appsIcon: {
    height: '24px',
    width: '24px',
  },
  appsIconOpen: {
    color: 'white',
  },
  keyboardArrow: {
    margin: `${theme.spacing(1.5)}px ${theme.spacing(0.5)}px`,
    '&.up': { color: 'white' },
    '&.down': { color: theme.evPalette.ocean[600] },
  },
  keyboardArrowRight: {
    color: 'inherit',
    margin: `${theme.spacing(1.5)}px ${theme.spacing(0.5)}px`,
  },
  popper: {
    zIndex: 10001,
  },
  appsList: {
    width: '100%',
    padding: '16px',
    overflow: 'scroll',
    '@media (min-width: 640px)': {
      maxHeight: '400px',
    },
  },
  listStyle: {
    padding: 0,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '& a': {
      color: theme.evPalette.charcoal[900],
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      fontWeight: '400',
      textDecoration: 'none',
      width: '100%',
      height: '100%',
      padding: '19px 24px',
    },
  },
  popperHeading: {
    display: 'flex',
    padding: '16px',
    width: '100%',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
  },
  menuOptionItem: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '12px !important',
    width: '100% !important',
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '12px',
      fontSize: '16px',
      fontWeight: '400',
    },
    '&.selected': {
      backgroundColor: theme.evPalette.ocean[600],
      borderRadius: '4px',
      color: 'white',
    },
  },
  appMenuDrawer: {
    marginTop: '60px',
    width: '300px',
  },
  appsMenuPaper: {
    position: 'static',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    background: theme.evPalette.salt[100],
    padding: '0px',
    '@media (min-width: 1024px)': {
      minWidth: '250px',
      height: 'fit-content',
      flexDirection: 'column',
    },
  },
  appsDrawerBackBtn: {
    width: '100%',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRadius: '0px',
    padding: '16px',
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '8px',
      color: theme.evPalette.ocean[600],
      justifyContent: 'flex-start',
    },
  },
  appIcons: {
    height: '24px',
    width: '24px',
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  retryBtn: {
    display: 'flex',
    height: '36px',
    padding: '10px',
    gap: '8px',
    width: '100%',
    '@media (min-width: 1024px)': {
      justifySelf: 'center',
      width: 'fit-content',
    },
  },
  retryLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '10px',
    textTransform: 'none',
  },
}));
